(function () {
  const getUseHref = (use) =>
    use?.getAttribute('href') || use?.getAttributeNS('http://www.w3.org/1999/xlink', 'href');

  const isSvgIconBroken = (svg) => {
    if (!svg) return false;
    if (svg.querySelector('path')) return false;

    const use = svg.querySelector('use');
    return !use || !getUseHref(use);
  };

  const fixSvgIcon = (svg, symbolId) => {
    if (!isSvgIconBroken(svg)) return false;

    const symbol = document.getElementById(symbolId);
    if (!symbol) return false;

    let use = svg.querySelector('use');
    if (!use) {
      use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
      svg.appendChild(use);
    }

    const href = `#${symbolId}`;
    use.setAttribute('href', href);
    use.setAttributeNS('http://www.w3.org/1999/xlink', 'href', href);
    return true;
  };

  const fixZipifyHeaderIcons = () => {
    document.querySelectorAll('.zpa-dynamic-header__icon-nav a[href="/cart"]').forEach((link) => {
      const svg = link.querySelector('.zpa-icons-list__item__icon');
      if (fixSvgIcon(svg, 'shopify-cart')) {
        link.classList.remove('zpa-icon--none');
      }
    });

    document.querySelectorAll('.zpa-nav .zpa-dynamic-header__nav__label').forEach((label) => {
      const svg = label.querySelector('.zpa-icons-list__item__icon');
      if (fixSvgIcon(svg, 'navbar-icon')) {
        label.classList.remove('zpa-icon--none');
      }
    });

    document
      .querySelectorAll('.zpa-dynamic-header__nav__item--close .zpa-dynamic-header__nav__label')
      .forEach((label) => {
        const svg = label.querySelector('.zpa-icons-list__item__icon');
        if (fixSvgIcon(svg, 'navbarIconClose')) {
          label.classList.remove('zpa-icon--none');
        }
      });
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', fixZipifyHeaderIcons)
    : fixZipifyHeaderIcons();
})();